import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=1d23d0ec&scoped=true"
import script from "./gateway.vue?vue&type=script&lang=js"
export * from "./gateway.vue?vue&type=script&lang=js"
import style0 from "./gateway.vue?vue&type=style&index=0&id=1d23d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23d0ec",
  null
  
)

export default component.exports